import AdminSettingsWrapper from "../../components/Admin/AdminSettingsPage/AdminSettingsWrapper/AdminSettingsWrapper";

type Props = {};

const AdminSettingsPage = (props: Props) => {
  return <AdminSettingsWrapper />;
};

export default AdminSettingsPage;
